module.exports = __webpack_public_path__ + "static/media/GTBSLong1w522@1x.a3de51ea.jpg";